import * as React from 'react';
import { FieldWrapper } from '@progress/kendo-react-form';
import editBtn from '../images/icon_edit.png'
import { Button } from '@progress/kendo-react-buttons';
 

const CusFormTitle = (props) =>{
    const {id, name, showEdit,...oth } = props;
 
    const clickEdit = React.useCallback(
        (e) => {
            e.preventDefault();
            props.onEdit(id);
        },
        []
    )

    return(
    <FieldWrapper>
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div style={{width:'100%'}}>
                <div className='pheader-left'>
                    <label id={id} style={{fontWeight:'500',fontSize:'large', wordBreak: 'break-word'}}>{name}</label>
                </div>
            </div>
       
            {showEdit &&
            <div className='pheader-right'>
                <span className='pheard-btn'
                    onClick={clickEdit}> 
                    <img src={editBtn} alt="imgedit"></img>
                    &nbsp;Edit
                </span>
            </div>}
            </div>
        </div>
    </FieldWrapper>
    )
}

export default CusFormTitle;